import styled from 'styled-components';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { Setting, SettingDetail, SettingInfo, SettingsSectionHeading } from 'components/Setting/style';

export const SaveButton = styled(Button).attrs({ size: 'small' })`
  justify-self: end;
`;

export const AdminAvailabilitySetting = styled(Setting)`
  & ${SettingInfo} {
    display: grid;
    grid-template-columns: subgrid;
    grid-area: 1 / 1 / 3 / 3;

    & > div {
      grid-column: 1 / 3;
      display: grid;
      grid-template-columns: subgrid;
      gap: 1rem;
    }
  }

  & ${SettingsSectionHeading} {
    grid-row: 1;
  }

  & ${SettingDetail} {
    display: grid;
    grid-template-columns: subgrid;
  }
`;
